var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWhitelist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.499,
    viewBox: "0 0 15 18.499",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29425",
    "data-name": "Group 29425",
    transform: "translate(161.336 -358.378)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48563",
    "data-name": "Path 48563",
    d: "M-150.919,359.5h-1.267a1.769,1.769,0,0,0-2.237-1.022,1.721,1.721,0,0,0-1.058,1.022h-1.266a.573.573,0,0,0-.584.563v2.248a.573.573,0,0,0,.584.563h5.832a.573.573,0,0,0,.583-.563v-2.251a.573.573,0,0,0-.586-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_23",
    "data-name": "Subtraction 23",
    d: "M18954.016,19525.135H18942.3a1.166,1.166,0,0,1-.811-.338,1.066,1.066,0,0,1-.326-.789v-13.5a1.153,1.153,0,0,1,1.172-1.131h1.16v1.689a1.738,1.738,0,0,0,1.75,1.691h5.83a1.73,1.73,0,0,0,1.75-1.691v-1.689h1.2a1.166,1.166,0,0,1,.811.338,1.072,1.072,0,0,1,.326.793v13.529A1.126,1.126,0,0,1,18954.016,19525.135Zm-8.973-7.711a1.012,1.012,0,0,0-.715,1.729l2.221,2.225a1,1,0,0,0,.715.295,1.023,1.023,0,0,0,.721-.295l4.482-4.484a1,1,0,0,0,.295-.715,1.044,1.044,0,0,0-.295-.721,1.016,1.016,0,0,0-1.436,0l-3.586,3.588a.251.251,0,0,1-.18.074.271.271,0,0,1-.184-.074l-1.322-1.324A1.013,1.013,0,0,0,18945.043,19517.424Z",
    transform: "translate(-19102.002 -19148.758)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWhitelist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_whitelist.af8980a30b05b8b7c10a94743972c296.svg";